"use strict";
import AOS from "aos";

import utils from "./scripts/lib/utils";
import stickyFooter from "./scripts/stickyFooter";
import toggleMenu from "./scripts/toggleMenu";
// import headerAdsControl from './scripts/headerAdsControl';
import headerScrolling from "./scripts/headerScrolling";
import checkUrlParam from "./scripts/checkUrlParam";
import copyLink from "./scripts/copyLink";
import saveUserLastPage from "./scripts/saveUserLastPage";
import asideFollowSocial from "./scripts/asideFollowSocial";
import asideFollowScroll from "./scripts/asideFollowScroll";
import loadSliderHome from "./scripts/loadSliderHome";
import loadMoreNews from "./scripts/loadMoreNews";
import ajustVideos from "./scripts/ajustVideos";
import podcastAuthorInfo from "./scripts/podcastAuthorInfo";
import loadNewsInSingle from "./scripts/loadNewsInSingle";
import shareSocialMidia from "./scripts/shareSocialMidia";
import loadComents from './scripts/loadComents';
import loadSearchPreview from "./scripts/loadSearchPreview";
import stickFooter from "./scripts/stickFooter";
import postImageZoon from "./scripts/postImageZoon";
import checkIsSafari from "./scripts/checkIsSafari";
import loadSvg from "./scripts/loadSvg";
import replaceSvg from "./scripts/podcasts/replaceSvg";
import loadInstagramPhotos from "./scripts/loadInstagramPhotos";
import toggleCardModal from "./scripts/toggleCardModal";
import modalComment from "./scripts/modalComment";
// import playVideo from './scripts/playVideo';
// import loadMp3Duration from "./scripts/loadMp3Duration";
import mainHomePodcastToggle from "./scripts/mainHomePodcastToggle";
import companyParallax from "./scripts/companyParallax";
import postCardCategoryLink from "./scripts/postCardCategoryLink";
import toggleFooterFixed from "./scripts/toggleFooterFixed";

// loadSvg();
console.log("start application");
AOS.init();

utils();
postCardCategoryLink();
headerScrolling();
stickyFooter();
toggleMenu();
// headerAdsControl();
checkUrlParam();
copyLink();
replaceSvg();
toggleFooterFixed();
saveUserLastPage();
asideFollowScroll();
asideFollowSocial();
loadMoreNews();
loadSliderHome();
ajustVideos();
podcastAuthorInfo();
loadNewsInSingle();
shareSocialMidia();
loadComents();
loadSearchPreview();
stickFooter();
postImageZoon();
checkIsSafari();
loadInstagramPhotos();
toggleCardModal();
modalComment();
// playVideo();
// loadMp3Duration();
mainHomePodcastToggle();
companyParallax();
